export const objButtons = [
    {id: 'benefits', name: 'Beneficios', icon: 'assets/header-footer/icon_beneficios.svg'},
    {id: 'offers', name: 'Niveles', icon: 'assets/header-footer/icon_promociones.svg'},
    {id: 'how-it-works', name: '¿Cómo funciona?', icon: 'assets/header-footer/icon_ComoFunciona.svg'},
    {id: 'payclub', name: 'PayClub', icon: 'assets/header-footer/icon_app.svg'},
    {id: 'app-home', name: 'APP', icon: 'assets/header-footer/icon_app.svg'},
    {id: 'locations', name: 'Sucursales', icon: 'assets/header-footer/icon_sucursales.svg'}
];

export const objLoginButtons = [
  {id: 'my-account', name: 'Mi cuenta', icon: 'assets/header-footer/icon_ComoFunciona.svg', link: 'dashboard/my-account/overview'},
  {id: 'benefits', name: 'Beneficios', icon: 'assets/header-footer/icon_beneficios.svg', link: 'dashboard/benefit/products/dishes'},
  {id: 'card', name: 'Tarjeta', icon: 'assets/header-footer/icon_promociones.svg', link: 'dashboard/card/details'},
  {id: 'notifications', name: 'Notificaciones', icon: 'assets/header-footer/icon_app.svg', link: 'dashboard/notifications'},
];
